import { makeAuthorizeHttpClientDecorator } from '../../decorators';
import { GetEmailWhitelist, SetEmailWhitelist } from 'domain/usecases/email-whitelist';
import { RemoteGetEmailWhitelist, RemoteSetEmailWhitelist } from 'data/usecases/bookkeeper';

export const makeRemoteGetEmailWhitelist = (): GetEmailWhitelist => {
  return new RemoteGetEmailWhitelist(makeAuthorizeHttpClientDecorator());
};

export const makeRemoteSetEmailWhitelist = (): SetEmailWhitelist => {
  return new RemoteSetEmailWhitelist(makeAuthorizeHttpClientDecorator());
};
